import apiHelperFactoryForBank from "@/http/apiHelperFactoryForBank";

const constitutionApiBank = {
  namespaced: true,

  state: {
    stokvelConstitutions: {},
  },

  mutations: {
    setStokvelConstitutions(state, payload) {
      state.stokvelConstitutions = payload;
    },

    resetState(state) {
      state.stokvelConstitutions = {};
    },
  },

  actions: {
    async getStokvelConstitutionReq({ commit }, payload = {}) {
      const useLoading = "useLoading" in payload ? payload.useLoading : true;

      if (useLoading) {
        commit("app/startLoading", null, { root: true });
      }

      commit("auth/setUseAppToken", true, { root: true });

      try {
        const getStokvelConstitutionRes =
          await apiHelperFactoryForBank.stokvelConstitution(
            payload.tenantIdentifier
          );

        // Remove 'documents' from the data before committing to store
        const { ...filteredData } = getStokvelConstitutionRes.data;

        commit("setStokvelConstitutions", filteredData);

        return getStokvelConstitutionRes;
      } catch (error) {
        if (error.response) {
          // handle response error
        } else if (error.request) {
          // handle request error
        } else {
          // handle other errors
        }
      } finally {
        if (useLoading) {
          commit("app/stopLoading", null, { root: true });
        }

        commit("auth/setUseAppToken", false, { root: true });
      }
    },

    async getStokvelConstitutionReqNoStore({ commit }, payload = {}) {
      const useLoading = "useLoading" in payload ? payload.useLoading : true;

      if (useLoading) {
        commit("app/startLoading", null, { root: true });
      }

      commit("auth/setUseAppToken", true, { root: true });

      try {
        const getStokvelConstitutionRes =
          await apiHelperFactoryForBank.stokvelConstitution(
            payload.tenantIdentifier
          );

        return getStokvelConstitutionRes;
      } catch (error) {
        if (error.response) {
          // handle response error
        } else if (error.request) {
          // handle request error
        } else {
          // handle other errors
        }
      } finally {
        if (useLoading) {
          commit("app/stopLoading", null, { root: true });
        }

        commit("auth/setUseAppToken", false, { root: true });
      }
    },
  },

  getters: {
    getStokvelConstitutions(state) {
      return state.stokvelConstitutions;
    },
  },
};

export default constitutionApiBank;
